import React, {FC, useState} from 'react'
// import { PageTitle } from "../../../../_metronic/layout/core";
// import {useIntl} from 'react-intl'
// import { Toolbar } from "../../../../_metronic/layout/components/toolbar/Toolbar";

// import clsx from 'clsx'
import {toAbsoluteUrl} from '../../../../_metronic/helpers'
import {MenuCard} from './components/MenuCard'
import {TopCommodityChartCard} from './components/TopCommodityChartCard'
import {TopCommodityTableCard} from './components/TopCommodityTableCard'
import {CommodityLineChartCard} from './components/CommodityLineChartCard'
import {CommodityDetailModal} from './components/CommodityDetailModal'
import {getListTradePartnerByCommodity, getCommodities} from './core/_request'
import useAxiosPrivate from '../../../libs/useAxiosPrivate'
import * as _ from 'lodash'
import {RTAsTableCard} from './components/RTAsTableCard'
import {useAuth} from '../../../modules/auth'
import {getNameByISO3} from '../../../libs/misc'

type Props = {
  className?: string
  bgColor?: string
  title?: string
  title2?: string
}

const HomePage: FC = ({className}: Props) => {
  const {currentUser} = useAuth()
  const reporterISO3User = currentUser?.economy
  // const intl = useIntl()
  const axiosPrivate = useAxiosPrivate()
  const [modalParam, setModalParam] = useState({
    show: false,
    commodity: '',
    description: '',
    iso3: reporterISO3User,
    partner: '',
    type: '', // chart or table
    commodityData: [],
    year: '',
    tradeflow: 'imports',
  })

  const handleToggleModal = () => {
    setModalParam((prev) => {
      if (!prev.show === false) {
        //Reset Modal
        return {
          ...prev,
          show: !modalParam.show,
          description: '',
          commodity: '',
          partner: '',
          type: '',
          commodityData: [],
          year: '',
          tradeflow: 'imports',
        }
      }
      return {
        ...prev,
        show: !modalParam.show,
      }
    })
  }

  const handleCommoditySelected = (
    hs: string,
    year: number,
    tradeflow: string,
    hsList: string | null,
    description: string
  ) => {
    handleToggleModal()
    getListTradePartnerByCommodity(axiosPrivate, {
      rep: reporterISO3User,
      hs: hsList !== '-' ? hsList : hs,
      year,
      tradeflow,
    })
      .then((res) => {
        const tradeData = res.data.data
        setModalParam((prev) => {
          return {
            ...prev,
            show: true,
            commodity: hs,
            description: description,
            type: 'chart',
            commodityData: tradeData,
            year: year.toString(),
            tradeflow,
          }
        })
      })
      .catch((err) => {
        console.error(err)
      })
  }

  const handleTopCountrySelected = (iso3: string, year: number, tradeflow: string) => {
    if (iso3) {
      handleToggleModal()
      getCommodities(axiosPrivate, {
        rep: reporterISO3User,
        par: iso3,
        tradeflow,
        year,
      })
        .then((res) => {
          const tradeData = res.data.data
          setModalParam((prev) => {
            return {
              ...prev,
              show: true,
              commodity: '',
              partner: iso3,
              type: 'table',
              commodityData: tradeData,
              year: year.toString(),
              tradeflow,
            }
          })
        })
        .catch((err) => {
          console.error(err)
        })
    }
  }

  return (
    <>
      {/* <PageTitle breadcrumbs={[]}>{intl.formatMessage({id: 'MENU.HOME'})}</PageTitle> */}
      {/* <Toolbar/> */}
      <div
        className='card mb-5 mb-xl-10'
        style={{
          backgroundImage: `linear-gradient(rgba(251, 161, 4, 0.65), rgba(251, 161, 4, 0.65) ), url("${toAbsoluteUrl(
            'media/misc/header-bg-blue.jpg'
          )}")`,
          backgroundPosition: 'center bottom',
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat',
        }}
      >
        <div className='card-body pt-9 pb-0 mb-15'>
          <div className='text-center mt-5 mb-15 text-white'>
            <h5 className='dss-portlet-dashboard-home-title text-white'>
              Thank you for negotiating for {getNameByISO3(reporterISO3User)}
            </h5>
            <span className='dss-portlet-dashboard-home-subtitle mt-10 animated fadeIn delay-1100ms'>
              What would you like to do next?
            </span>
          </div>
          <div className='negotiating-list'>
            <div className='negotiating-item'>
              <MenuCard
                svgPath='media/icons/duotune/general/gen008.svg'
                title={`RTA Simulation (${getNameByISO3(reporterISO3User)})`}
                subtitle={`Examine the impact of potential bilateral RTAs involving ${getNameByISO3(
                  reporterISO3User
                )} using Partial Equilibrium analysis.`}
                link={`/third-party-impacts?rep=${reporterISO3User}`}
              />
            </div>
            <div className='negotiating-item'>
              <MenuCard
                svgPath='media/icons/duotune/text/txt001.svg'
                title='RTA Simulation (Third Parties)'
                subtitle={`Examine the impact on ${getNameByISO3(
                  reporterISO3User
                )} of potential third-party RTAs using Partial Equilibrium analysis.`}
                link='/third-party-impacts'
              />
            </div>
            <div className='negotiating-item'>
              <MenuCard
                svgPath='media/icons/duotune/finance/fin007.svg'
                title='Input/Output Analysis'
                subtitle={`See the impact of ${getNameByISO3(
                  reporterISO3User
                )}'s potential free trade agreements on other sectors using input/output table analysis`}
                link='/input-output-analysis'
              />
            </div>
            <div className='negotiating-item'>
              <MenuCard
                svgPath='media/icons/duotune/maps/map001.svg'
                title='Explore Trade Prospects'
                subtitle='Use this feature to help decide which economies to negotiate with or which markets to target for specific products'
                link='/trade-prospect'
              />
            </div>
            <div className='negotiating-item'>
              <MenuCard
                svgPath='media/icons/duotune/graphs/gra003.svg'
                title='Preference Loss Simulation'
                subtitle='Set a custom scenario and determine the impact of excluding preferential trade agreements.'
                link={`${process.env.REACT_APP_TINA_BASE_URL}/app/start/${reporterISO3User}/preference-loss`}
                type='external'
              />
            </div>
            <div className='negotiating-item'>
              <MenuCard
                svgPath='media/icons/duotune/general/gen004.svg'
                title='RTA Text Search'
                subtitle='Search through texts of RTAs and multilateral agreements and interpret them using AI.'
                link={`${process.env.REACT_APP_LEGAL_TINA_BASE_URL}/app/search`}
                type='external'
              />
            </div>
            <div className='negotiating-item'>
              <MenuCard
                svgPath='media/icons/duotune/general/gen005.svg'
                title='RTA Text Comparison'
                subtitle={`Compare existing texts of RTAs involving ${getNameByISO3(
                  reporterISO3User
                )} as well as other economies.`}
                link={`${process.env.REACT_APP_LEGAL_TINA_BASE_URL}/app/compare/?iso=${reporterISO3User}`}
                type='external'
              />
            </div>
            <div className='negotiating-item'>
              <MenuCard
                svgPath='media/icons/duotune/communication/com014.svg'
                title='Service Gateway'
                subtitle='Explore and compare schedules of specific commitments and reservations'
                link={`${process.env.REACT_APP_LEGAL_TINA_BASE_URL}/app/services`}
                type='external'
              />
            </div>
            <div className='negotiating-item-lg'>
              <MenuCard
                svgPath='media/logos/logo-tina-sticky-sm.svg'
                svgClassName='me-3'
                title='TINA Trade'
                subtitle='Explore additional TINA tools, such as generating offensive/defensive priorities, trade facilitation, trade data discrepancies and more.'
                link={`${process.env.REACT_APP_TINA_BASE_URL}`}
                type='external'
              />
            </div>
            <div className='negotiating-item-lg'>
              <MenuCard
                svgPath='media/logos/logo-legal-tina-sticky-sm.svg'
                svgClassName='me-3'
                title='Legal TINA'
                subtitle='Learn more about RTA issue areas, including best practices about incorporating them, their trade-offs and more.'
                link={`${process.env.REACT_APP_LEGAL_TINA_BASE_URL}`}
                type='external'
              />
            </div>
          </div>
        </div>
      </div>

      <div className='row g-5 g-xl-8'>
        <div className='col-xl-6'>
          <TopCommodityChartCard handlePartnerClicked={handleTopCountrySelected} />
        </div>
        <div className='col-xl-6'>
          <TopCommodityTableCard handleHSClicked={handleCommoditySelected} />
        </div>
      </div>
      <div className='row g-5 g-xl-8 mt-1'>
        <div className='col-xl-12'>
          <CommodityLineChartCard />
        </div>
      </div>
      <div className='row g-5 g-xl-8 mt-1'>
        <div className='col-xl-12'>
          <RTAsTableCard />
        </div>
      </div>
      <CommodityDetailModal params={modalParam} handleDisplayToggle={handleToggleModal} />
    </>
  )
}

export default HomePage
